import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { extendObservable } from 'mobx'
import Spinner from '@components/spinner'
import Pagination from '@components/Pagination'
import { clientContactApi } from '@atheneum/api'
import { observer, inject } from 'mobx-react'
import queryString from 'query-string'

class ContactsMissingLinkedinUrl extends Component {
  constructor (props) {
    super(props)

    extendObservable(this, {
      hilight: null,
      clients: [],
      loading: false,
      count: 0,
      page: 1
    })

    this.loadContacts(this.page)
  }

  loadContacts = async (page = 1) => {
    this.loading = true
    const { rows, count } = await clientContactApi.getContactsWithoutLinkedin(page)
    this.clients.replace(rows)
    this.count = count
    this.page = page
    this.loading = false
  }

  addLink = async (e, client) => {
    e.preventDefault()
    const link = await prompt(
      `Enter professional link URL to add to ${client.fullName}`
    )
    if (!link) return false
    try {
      await clientContactApi.addProfessionalLink(client.id, link.split('?')[0])
      this.props.growlStore.showSuccess(
        'Professional link added to ' + client.fullName
      )
    } catch (err) {
      this.props.growlStore.showError(
        'Error adding professional link to client'
      )
    }
    await this.loadContacts()
    return false
  }

  render () {
    return (
      <div style={{ padding: 25 }}>
        <h2>Client contacts without professional link URL</h2>
        {this.loading && <Spinner />}
        {!this.loading && (
          <>
            <table className='table-wrapper'>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Company Name</th>
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.clients.map(c => (
                  <tr
                    onClick={() => (this.hilight = c.id)}
                    style={{
                      background: this.hilight === c.id ? '#F9F9FC' : 'white'
                    }}
                  >
                    <td>
                      <Link to={'/client-contact/' + c.id}>{c.fullName}</Link>
                    </td>
                    <td>{c.companyName}</td>
                    <td>
                      <a
                        target='_blank'
                        rel='noreferrer'
                        href={`https://www.linkedin.com/search/results/all/?${queryString.stringify(
                          {
                            keywords: c.fullName + ' ' + c.companyName
                          }
                        )}`}
                        title='Open linkedin search page prefilling client name and company in the search bar.'
                      >
                        Find on linkedin
                      </a>
                    </td>
                    <td>
                      <a href='' onClick={e => this.addLink(e, c)}>
                        Add professional Link
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              total={this.count}
              perPage={15}
              page={this.page}
              onChange={page => this.loadContacts(page)}
            />
          </>
        )}
      </div>
    )
  }
}

export default inject('growlStore')(observer(ContactsMissingLinkedinUrl))
